/**
 * 画面の URL パス定数。
 *
 * バックエンドの変更通知メールが画面へのリンクを組み立てる側
 * (`lambda/control-panel-api/master_change_notify.py` の `PAGE_PATH_*`) と値を揃える。
 */

/** マスタ変更履歴の画面 (マスタ変更履歴 SBI 7)。クエリは `master_type` / `entity_key` / `rev` */
export const PAGE_PATH_MASTER_HISTORY = '/master-history';

/**
 * マスタ変更履歴から「遷移元の現場WG画面」へ戻るときの行き先 (マスタ種別ごと)。
 *
 * `App.tsx` の Route と同じ値。履歴画面は各マスタ画面の導線から入るため、
 * 戻り先は対象のマスタ種別から一意に決まる。
 */
export const PAGE_PATH_BROADCAST_POINTS = '/';
export const PAGE_PATH_DEVICES = '/devices';
export const PAGE_PATH_CHIMES = '/chimes';
export const PAGE_PATH_PHRASE_TEMPLATES = '/phrase-templates';
export const PAGE_PATH_SSML_DICTIONARY = '/ssml-dictionary';
export const PAGE_PATH_FREE_TEXT_TEMPLATES = '/free-text-templates';
export const PAGE_PATH_PERMISSION_GROUPS = '/admin/permission-groups';
